<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'

    @Component
    export class HotelAmenities extends Vue {
        @Prop() info

        render() {
            return null
        }
    }

    export default HotelAmenities
</script>
